import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

const usePreviousRoute = () => {
  const router = useRouter();
  const prevRoute = useRef(null);

  useEffect(() => {
    const handleRouteChange = (url) => {
      prevRoute.current = router.asPath;
    };

    router.events.on('routeChangeStart', handleRouteChange);

    return () => {
      router.events.off('routeChangeStart', handleRouteChange);
    };
  }, [router]);

  return prevRoute.current;
};

export default usePreviousRoute;
